import { render } from "./AlbumsIndividual.vue?vue&type=template&id=1f83fa73"
import script from "./AlbumsIndividual.vue?vue&type=script&lang=js"
export * from "./AlbumsIndividual.vue?vue&type=script&lang=js"

import "./AlbumsIndividual.vue?vue&type=style&index=0&id=1f83fa73&lang=scss"

import exportComponent from "/Users/michellmonroy/Documents/dev-glider/catalogue-api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__